export const CAMPAIGN_REMINDER_FORM_ID = 2087

export const CAMPAIGN_REMINDER_SEND_STATUS = {
  FAILED: 'Failed',
  PENDING: 'Pending',
  SENT: 'Sent',
  SKIPPED: 'Skipped',
} as const
